module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isDestinationBlank) ? _c('v-row', {
    attrs: {
      "align": "center",
      "justify": "start",
      "no-gutters": ""
    }
  }, _vm._l((_vm.params.value), function(destination) {
    return _c('v-col', {
      key: destination,
      staticClass: "pa-1",
      attrs: {
        "cols": "2",
        "sm": "3",
        "md": "7",
        "lg": "5",
        "xl": "2"
      }
    }, [_c('v-img', {
      attrs: {
        "contain": "",
        "src": _vm.destinationImage(destination),
        "aspect-ratio": "1"
      }
    })], 1)
  }), 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b680480","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/DestinationsRenderer.vue
// module id = 2138
// module chunks = 0